import EventEmitter from 'events';

const eventBus = new EventEmitter();
export default eventBus;

export const EDITOR_FS_DOM_READY = 'editorFsDomReady';
export const EDITOR_DOM_READY = 'editorDomReady';
export const SIDEBAR_WIDTH_CHANGE = 'sidebarWidthChange';
export const ON_SEARCH = 'onSearchFromSearchPage';
export const UPDATE_SEARCH_QUERY = 'updateSearchQuery';
export const DEPOSIT_KNOWLEDGE_COIN = 'onGiveCoin';

// 智能评分Tips点击
export const AI_AGENT_TIPS_CLICK = 'aiAgentTipsClick';
// 智能评分，点击提示进入编辑模式
export const GRADE_TIP_ENTER_EDIT = 'gradeTipEnterEdit';
// 智能评分，接收到新的评分
export const RECEIVE_NEW_GRADE = 'receiveNewGrade';
// 智能评分，需要重新开启评分
export const RESTART_AI_AGENT = 'restartAiAgent';
// 智能评分，需要重新开启评分
export const CLOSE_AI_AGENT_AUTO = 'closeAiAgentAuto';
// 超级助理输入框Focus事件
export const ASSISTANT_INPUT_FOCUS = 'sssistantInputFocus';

// 常用文档
export const ADD_COMMON_DOC_SUCCESS = 'addCommonDocSuccess';
export const REMOVE_COMMON_DOC_SUCCESS = 'removeCommonDocSuccess';

// 如流待办初始渲染完成
export const ONLINE_TODO_INIT_COMPLETE = 'onlineTodoInitComplete';

// sdk获取user完成
export const GET_USER_INFO_SUCCESS = 'getUserInfoSuccess';

// flow js 加载完成
export const FLOW_JS_LOADED = 'FLOW_JS_LOADED';

// 在超级助理中推荐文档
export const RECOMMEND_DOC_IN_AICHAT = 'recommendDocInAiChat';

// 数据表通知，打开数据表权限设置面板
export const OPEN_DATASHEET_PERMISSION = 'openDatasheetPermission';

// 添加模板到模板库
export const ADD_MATERIAL = 'addMaterial';
// 点击从模板库添加
export const CLICK_ADD_MATERIAL = 'clickAddMaterial';
// 文档初始化完成
export const DOCUMENT_INIT_COMPLETE = 'documentInitComplete';
// 手动切换普通/卡片视图
export const DOCUMENT_VIEW_CLICK_CHANGE = 'documentViewClickChange';
// 关于我的用户引导事件
export const DOCUMENT_ABOUT_ME_GUIDE_EVENT = 'documentAboutMeEvent';
// 定位到底部评论
export const DOCUMENT_SCROLL_BOTTOM_COMMENT_EVENT = 'documentScrollBottomEvent';

// 文档组件加载完成事件
export const LOAD_EXTENSION_COMPLETE = 'loadExtensionComplete';
// 评论tab 评论信息发生改变事件
export const COMMENT_INFO_CHANGE = 'commentInfoChange';
// 评论列表变化事件
export const COMMENT_LIST_CHANGE = 'commentListChange';
// 随心搭组件被删除
export const FLEX_BUILDER_DELETE = 'flexBuilderDelete';
// 随心搭对话生成 Artifact 组件完成
export const FLEX_BUILDER_GENERATE_ARTIFACT_COMPLETE = 'flexBuilderGenerateArtifactComplete';
// 编辑随心搭
export const EDIT_FLEX_BUILDER = 'editFlexBuilder';
// 随心搭独立成卡
export const CHANGE_FLEX_BUILDER_CARD_STATUS = 'changeFlexBuilderCardStatus';
// 点击随心搭 Logo
export const CLICK_FLEX_BUILDER_LOGO = 'clickFlexBuilderLogo';
// 随心搭错误重试场景下的发送消息事件
export const FLEX_BUILDER_SUBMIT_MESSAGE_FOR_ERROR_RETRY = 'flexBuilderSubmitMessageForErrorRetry';
// 随心搭错误重试场景下的重试按钮点击事件
export const FLEX_BUILDER_ERROR_RETRY_BUTTON_CLICK = 'flexBuilderErrorRetryButtonClick';
// 随心搭发送消息事件
export const FLEX_BUILDER_SUBMIT_MESSAGE = 'flexBuilderSubmitMessage';
// 随心搭 chat onFinish 事件
export const FLEX_BUILDER_CHAT_FINISH = 'flexBuilderChatFinish';
